import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";



function PJPaymentFrame(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className={"order-frame my-auto complete-order journey-step " + props.current}>
            <div className="frame-content d-flex flex-column">
                <h3 className="center has-violet-color">CHECKOUT</h3>
                <div className="payment flex-fill">
                    {props.current &&
                    <iframe src="/purchase/MediaOrderDetails">

                    </iframe>
                    }
                </div>
            </div>


            <div className="journey-nav container">
                <div className="row">
                    <div className="col-3 my-auto">
                        <div className="go-back-button wp-block-button aligncenter is-style-outline">
                            <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_5b_PERSONAL_DETAILS} })}  className="wp-block-button__link has-text-color has-light-red-color arrow-back">Go back</button>
                        </div>
                    </div>

                    <div className="col-6 my-auto">

                    </div>
                </div>
            </div>
        </div>
    );
}

export { PJPaymentFrame };